export const STATUS = {
  DRAFT: { id: 'DRAFT', name: 'Draf' },
  CONFIRMED: { id: 'CONFIRMED', name: 'Dikonfirmasi' },
  EXPIRED: { id: 'EXPIRED', name: 'Kadaluwarsa' },
  CANCELED: { id: 'CANCELED', name: 'Dibatalkan' },
  CLOSED: { id: 'CLOSED', name: 'Ditutup' },
}

const statusTransitions = {
  Draf: [
    {
      status: STATUS.CANCELED,
      isRedText: true,
    },
  ],
  Dikonfirmasi: [
    {
      status: STATUS.CANCELED,
      isRedText: true,
    },
    {
      status: STATUS.CLOSED,
      isRedText: true,
    },
  ],
  Kadaluwarsa: [],
  Dibatalkan: [],
  Ditutup: [],
}

export default statusTransitions